import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// External service booking destination
export const BOOKING_URL = "https://tjclinical.solutions/";

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function submitContact(payload) {
  const { data } = await api.post("/contact", payload);
  return data;
}
